import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";



class SectionMisVis extends React.Component {
  render() {
    const { classes } = this.props;
       return (
      <div className={classes.section}>
     
        <div className={classes.container}>
          <GridContainer>
            <GridItem  xs={12} sm={12} md={8} className={classes.marginAuto}>
                <div>
               <h1 classeName={classes.tit}> Mission</h1>
            <hr/>
               <h5>  
                  <i class="fa fa-quote-left" style={IconStyle}></i>
                  MGEC aims to deliver economically viable and sustainable solutions that will benefit the society for now and the developing future. 
                  <i class="fa fa-quote-right" style={IconStyle}></i>
               </h5>
                <h1> Vision</h1>
                <hr/>
               <h5>  
                 <i class="fa fa-quote-left" style={IconStyle}></i>
                  MGEC aims to be trustworthy and accountable partner for both business partners and clients.
                  <i class="fa fa-quote-right" style={IconStyle}></i>
               </h5>
               </div>
                        
              <br/>
              <br/>
              <br/>
             </GridItem>
            </GridContainer>
          
      </div>
     </div> 

    );
  }
}
const IconStyle={
    fontSize: '24px',
    paddingLeft: '3px',
    paddingRight: '3px',
}


export default withStyles(carouselStyle)(SectionMisVis);



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionMisVis.jsx